import { StreetTypeName } from './StreetTypeName'

export class StreetType {
  private _code: string
  private _name: StreetTypeName

  constructor (code: string, name: StreetTypeName) {
    const parsedCode = parseInt(code, 10)
    if (isNaN(parsedCode) || parsedCode < 1) {
      throw new TypeError('StreetType code not valid')
    }
    this._code = code
    this._name = name
  }

  code (): string {
    return this._code
  }

  name (): string {
    return this._name.value()
  }
}
